import React from "react";
import MCSReadonlyField from '../MCSReadonlyField';
import { SubscriptionHelper } from "../../_helpers/SubscriptionHelper";

const SubscriptionFeeField = (props) => {
    const subscriptionType = props.subscriptionType;
    const recurringType = props.recurringType;
    let labelName = SubscriptionHelper.GetSubscriptionFeeDescription(subscriptionType, recurringType);

    return (
        <>
            {labelName != null && labelName != "" &&
                <MCSReadonlyField label={labelName} text={props.amount} />}
        </>
    );
};

export default SubscriptionFeeField;
